import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Property } from '../../models/property';
import { ApplicationDataService } from '../../../services/application.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AnalyticsService } from 'services/analytics.service';
import { Application } from '../../models/application';

@Component({
  selector: 'app-invitation',
  template: ''
})
export class InvitationComponent implements OnInit {
  private sub: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private applicationService: ApplicationDataService,
    private readonly analyticsService: AnalyticsService) {
    this.analyticsService.track(
      'HRA Application',
      'Invitation',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
  }

  private additionalAnalyticsDetails(): any {
    try {
      return {};
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  ngOnInit() {
    const invitationID: string = window.localStorage.getItem('InvitationID');

    this.applicationService.acceptInvitation(invitationID)
      .subscribe(res => this.acceptInvitation(res), err => this.invitationError(err));
  }

  invitationError(err: HttpErrorResponse) {
    window.localStorage.removeItem('InvitationID');
    var errorContents = err;
    if (err.status === 403) {
      this.analyticsService.track(
        'HRA Application',
        'Invitation',
        'End',
        'Error: Invitation 403',
        '/login',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/login']);
    }
    else if (errorContents.error.Message !== null && errorContents.error.Message !== undefined) {
      this.analyticsService.track(
        'HRA Application',
        'Invitation',
        'End',
        'Error: Invitation error with message',
        '/login',
        {
          ...this.additionalAnalyticsDetails(),
          'ErrorMessage': errorContents.error.Message
        });
      this.router.navigate(['/application/dashboard', 'inviteError', errorContents.error.Message]);
    }
    else {
      this.analyticsService.track(
        'HRA Application',
        'Invitation',
        'Stop',
        'Error: Invitation error',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }
  }

  acceptInvitation(data: any) {
    if (typeof data == "string") { // this.applicationService.acceptInvitation(invitationID) may return a string with an error message
      this.analyticsService.track(
        'HRA Application',
        'Invitation',
        'Stop',
        'Error: Invitation accept error',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard', 'inviteError', data]);
    }
    else {
      this.analyticsService.track(
        'HRA Application',
        'Invitation',
        'Stop',
        'Invitation accepted, sending to dashboard',
        '/application/dashboard',
        this.additionalAnalyticsDetails());

      const invitationID = window.localStorage.getItem('InvitationID');
      window.localStorage.setItem('RentalApplicantKey', data.toString());
      // Get the application details and continue directly
      this.applicationService.getInvitationApplication(invitationID)
        .subscribe(
          res => this.continueInvitedApplication(res),
          err => {
            window.localStorage.removeItem('InvitationID');
            this.router.navigate(['/application/dashboard', 'inviteError', 'Unable to load application']);
          }
        );

    }
  }

  onGetProperty(property: Property[]) {
    localStorage.setItem('SelectedProperty', JSON.stringify(property));
  }
  
  continueInvitedApplication(application: Application) {
    window.localStorage.removeItem('InvitationID');
    if (application.RentalApplicationKey !== 0) {
      localStorage.setItem('YardiKey', application.YardiKey);
      localStorage.setItem('RentalApplicationKey', application.RentalApplicationKey.toString());
      this.applicationService.getProperty(application.YardiKey).subscribe(res => this.onGetProperty(res.results));
      if (application.UnitCode != null) {
        localStorage.setItem('mfunitcode', application.UnitCode);
      }
      // Navigate directly to basic application page
      this.analyticsService.track(
        'HRA Application',
        'Invitation',
        'Stop',
        'Invitation accepted, continuing application',
        '/application/basic',
        this.additionalAnalyticsDetails()
      );
      this.router.navigate(['/application/basic']);
    } else {
      // Fallback to dashboard for edge cases
      this.router.navigate(['/application/dashboard']);
    }
  }
}
